import { useEffect, useState } from "react";
import type { User } from "../types";
import { api } from "../lib/api";
import { Avatar } from "./ui";

export default function UserAvatar({
  user,
  size = "md",
  tone = 0
}: {
  user: User;
  size?: "sm" | "md" | "lg";
  tone?: number;
}) {
  const [imageUrl, setImageUrl] = useState<string>();

  useEffect(() => {
    setImageUrl(undefined);
    if (!user.photoPath) return;
    let active = true;
    let objectUrl: string | undefined;
    void api.userPhoto(user.id).then((blob) => {
      objectUrl = URL.createObjectURL(blob);
      if (active) setImageUrl(objectUrl);
      else URL.revokeObjectURL(objectUrl);
    }).catch(() => {
      if (active) setImageUrl(undefined);
    });
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [user.id, user.photoPath]);

  return <Avatar name={`${user.firstName} ${user.lastName}`} size={size} tone={tone} imageUrl={imageUrl} />;
}
